import Link from "next/link";
import { getMessages } from "@/lib/i18n/messages";
import { withLocalizedArticlePath } from "@/lib/utils/localePath";
import type { AppLocale } from "@/lib/utils/i18n";

type BreakingNewsTickerProps = {
  locale: AppLocale;
  items: Array<{ id: string; slug: string; title: string; categorySlug: string }>;
  compact?: boolean;
};

const BreakingNewsTicker = ({ locale, items, compact = false }: BreakingNewsTickerProps) => {
  void compact;
  const messages = getMessages(locale);
  const tickerItems = items.length > 0 ? [...items, ...items] : [];

  if (tickerItems.length === 0) {
    return null;
  }

  return (
    <div className="group bg-[#8f1111] text-white">
      <div className="mx-auto flex w-full max-w-6xl items-center gap-3 px-3 py-2 transition-all duration-300">
        <span
          className="inline-flex shrink-0 items-center gap-2 rounded-full border border-white/30 bg-black/35 px-3 py-1 text-xs font-bold text-white transition-all duration-300"
        >
          <span
            className="h-2.5 w-2.5 animate-pulse rounded-full bg-[#ffd166] transition-all duration-300"
          />
          {messages.articlePage.breaking}
        </span>

        <div className="relative w-full overflow-hidden">
          <div className="ticker-track whitespace-nowrap text-sm [animation-play-state:running] group-hover:[animation-play-state:paused]">
            {tickerItems.map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                href={withLocalizedArticlePath(locale, item.categorySlug, item.slug)}
                className="mx-6 inline-block text-white transition-all duration-300"
              >
                {item.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreakingNewsTicker;
